export function formatDurationTime(duration: string): string {
  // Due to design requirement if 0 min is returned we are showing 1m instead
  return duration === '0m late' ? '1m late' : duration;
}
